module.exports = __webpack_public_path__ + "static/media/my_evaluation_blue.135da945.svg";